import { render, staticRenderFns } from "./SnapshotButton.vue?vue&type=template&id=64117e47&"
import script from "./SnapshotButton.vue?vue&type=script&lang=js&"
export * from "./SnapshotButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports